module.exports = __webpack_public_path__ + "media/games-10.1bcefa6c.mp4";